import { http } from 'utils'
import { SET_ITEMS, SET_SELECTED } from 'vx/mutations'
import { set } from 'lodash'

export default {
  namespaced: true,

  state: {
    garments: [],
    meta: null
  },

  actions: {
    async getGarments ({ commit, state }, { deliveryRunId, params = {} } = {}) {
      const response = await http.get(`delivery-runs/${deliveryRunId}/pending-garments`, { params })

      commit(SET_ITEMS, response.data.data)

      return response
    },

    scan ({ commit }, { serial, deliveryRunId, containerId }) {
      return http.post(`delivery-runs/${deliveryRunId}/pending-garments`, { serial: serial, container_id: containerId })
    },

    remove ({ commit }, { serial, deliveryRunId }) {
      return http.delete(`delivery-runs/${deliveryRunId}/pending-garments`, { data: { serial: serial } })
    },

    resetGarments ({ commit }) {
      commit(SET_ITEMS, [])
    },

    setSelected ({ commit }, { garment, added }) {
      commit(SET_SELECTED, { garment, added })
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.garments = items
    },

    [SET_SELECTED] (state, { garment, added }) {
      const gar = state.garments.find(item => item.id === garment)
      set(gar, 'added', added)
    }
  }
}
